import { IFieldsMapContainerContext, IFieldsMapContainerOptions, IFieldsMapFactory } from "../map"
import { FieldsMap } from "./fieldsMap"

export class FieldsMapFactory implements IFieldsMapFactory {

    static $inject = ["OmniaFieldsMapContext"]

    constructor(
        public readonly context: IFieldsMapContainerContext
    ) {

    }

    public createMap(options?: IFieldsMapContainerOptions): FieldsMap {
        return new FieldsMap(this.context, options)
    }

}
